
import validationPatterns from "./validationPatterns";

export const GB_fieldPatterns = {
    
    Shipment : {
        // mucr : {
        //     ...validationPatterns.AN,
        //     optional : true,
        //     minLength: 14,
        //     maxLength: 35,
        //     fieldName : "MUCR/GMR"
        // },
        declarationEntryType : {
            ...validationPatterns.A,
            optional : false,
            minLength: 1,
            maxLength: 1,
            fieldName : "Dec Type"
        },

        ref: {
            ...validationPatterns.U,
            optional : true,
            minLength: 1,
            maxLength: 35,
            fieldName : "Doc Reference"
        },
        status: {
            ...validationPatterns.U,
            optional : false,
            minLength: 1,
            maxLength: 35,
            fieldName : "Doc Status"
        },
        reason: {
            ...validationPatterns.P,
            optional : true,
            minLength: 1,
            maxLength: 70,
            fieldName : "Doc Reason"
        },
        part: {
            ...validationPatterns.AN,
            optional : true,
            minLength: 0,
            maxLength: 5,
            fieldName : "Doc Part"
        },
        quantity: {
            ...validationPatterns.N11D3,
            optional : true,
            minLength: 1,
            maxLength: 14,
            fieldName : "Doc Quantity"
        },
        additionalInfoCode: {
            ...validationPatterns.P,
            optional : true,
            minLength: 5,
            maxLength: 5,
            fieldName : "Additional info Code"
        },
        additionalStatementText: {
            ...validationPatterns.P,
            optional : true,
            minLength: 1,
            maxLength: 70,
            fieldName : "Additional Info Statement Text"
        },
        declarantRepType : {
            ...validationPatterns.N,
            optional : false,
            minLength: 1,
            maxLength: 1,
            fieldName : "Representation Type"
        },
        transportMOP : {
            ...validationPatterns.A,
            optional : false,
            minLength: 1,
            maxLength: 1,
            fieldName : "Transport MOP"
        },
        mrn : {
            ...validationPatterns.AN,
            optional : true,
            minLength: 18,
            maxLength: 18,
            fieldName : "MRN"
        },
        countryOfDispatch : {
            ...validationPatterns.A,
            optional : false,
            minLength: 2,
            maxLength: 2,
            fieldName : "Country Of Dispatch"
        },
        voyageId : {
            ...validationPatterns.P,
            optional : false,
            minLength: 1,
            maxLength: 27,
            fieldName : "VOYG/FLT/TRK ID"
        },
        carrierName : {
            ...validationPatterns.P,
            optional : true,
            minLength: 1,
            maxLength: 35,
            fieldName : "Carrier Name"
        },
        transportNationality : {
            ...validationPatterns.A,
            optional : true,
            minLength: 2,
            maxLength: 2,
            fieldName : "Transport Nationality"
        },
        locationOfGoods  : {
            ...validationPatterns.AN,
            optional : false,
            minLength: 1,
            maxLength: 17,
            fieldName : "Location Of Goods"
        },
        inlandTransportId : {
            ...validationPatterns.P,
            optional : true,
            minLength: 1,
            maxLength: 27,
            fieldName : "Transport Inland Id"
        },
        mop : {
            ...validationPatterns.A,
            optional : false,
            minLength: 1,
            maxLength: 1,
            fieldName : "Transport Mode Of Payment"
        },
        destinationCountry : {
            ...validationPatterns.A,
            optional : false,
            minLength: 2,
            maxLength: 2,
            fieldName : "Destination Country"
        },
        regConsignorEORINumber: {
            ...validationPatterns.eoriNumber,
            optional : true,
            minLength: 14,
            maxLength: 17,
            fieldName : "Registered Consignor EORI Number"
        },
        regConsigneeEORINumber: {
            ...validationPatterns.eoriNumber,
            optional : true,
            minLength: 14,
            maxLength: 17,
            fieldName : "Registered Consignee EORI Number"
        },
        govtContractorEORINumber:{
            ...validationPatterns.eoriNumber,
            optional : true,
            minLength: 14,
            maxLength: 17,
            fieldName : "GOVT Contractor EORI number" 
        },
        warehouseNumber: {
            ...validationPatterns.AN,
            optional : true,
            minLength: 1,
            maxLength: 17,
            fieldName : "Warehouse Number"
        },
    },

    Actor: {
    declarantFullName : {
        ...validationPatterns.P,
        optional : false,
        minLength: 1,
        maxLength: 35,
        fieldName : "Declarant Name"
    },   
    declaranteoriNumber : {
        ...validationPatterns.eoriNumber,
        optional : false,
        minLength: 14,
        maxLength: 17,
        fieldName : "Declarant Eori Number"
    },
    consigneeFullName : {
        ...validationPatterns.P,
        optional : false,
        minLength: 1,
        maxLength: 35,
        fieldName : "Consignee Name"
    },
    consigneeeoriNumber : {
        ...validationPatterns.eoriNumber,
        optional : false,
        minLength: 14,
        maxLength: 17,
        fieldName : "Consignee Eori Number"
    },
    consignereoriNumber : {
        ...validationPatterns.eoriNumber,
        optional : false,
        minLength: 14,
        maxLength: 17,
        fieldName : "Consignor  Eori Number"
    },
    consignerFullName : {
        ...validationPatterns.P,
        optional : false,
        minLength: 1,
        maxLength: 35,
        fieldName : "Consignor Name"
    }, 
    consigneraddressLine1: {
        ...validationPatterns.P,
        optional: false,
        minLength: 0,
        maxLength: 70,
        fieldName: "Consignor Address Line 1",
      },
      consigneeaddressLine1: {
        ...validationPatterns.P,
        optional: false,
        minLength: 0,
        maxLength: 70,
        fieldName: "Consignee Address Line 1",
      },
      declarantaddressLine1: {
        ...validationPatterns.P,
        optional: false,
        minLength: 0,
        maxLength: 70,
        fieldName: "Declarant Address Line 1",
      },
      consignercity: {
        ...validationPatterns.CITY,
        optional: false,
        minLength: 0,
        maxLength: 35,
        fieldName: "Consignor City",
      },
      declarantcity: {
        ...validationPatterns.CITY,
        optional: false,
        minLength: 0,
        maxLength: 35,
        fieldName: "Declarant City",
      },
      consigneecity: {
        ...validationPatterns.CITY,
        optional: false,
        minLength: 0,
        maxLength: 35,
        fieldName: "Consignee City",
      },
      consigneezipcode: {
        ...validationPatterns.POSTAL_CODE,
        optional: false,
        minLength: 0,
        maxLength: 9,
        fieldName: "Consignee Postal Code",
      },
      consignerzipcode: {
        ...validationPatterns.POSTAL_CODE,
        optional: false,
        minLength: 0,
        maxLength: 9,
        fieldName: "Consignor Postal Code",
      },
      declarantzipcode: {
        ...validationPatterns.POSTAL_CODE,
        optional: false,
        minLength: 0,
        maxLength: 9,
        fieldName: "Declarant Postal Code",
      },
      consignercountry: {
        ...validationPatterns.P,
        optional: false,
        minLength: 2,
        maxLength: 2,
        fieldName: "Consignor Country",
      },
      consigneecountry: {
        ...validationPatterns.P,
        optional: false,
        minLength: 2,
        maxLength: 2,
        fieldName: "Consignee Country",
      },
      declarantcountry: {
        ...validationPatterns.P,
        optional: false,
        minLength: 2,
        maxLength: 2,
        fieldName: "Declarant Country",
      }
    },
    Invoice: {
        currency: {
            ...validationPatterns.A,
            optional: false,
            minLength: 3,
            maxLength: 3,
            fieldName: "Invoice Currency"
        },
        shipmentValueCurrency: {
            ...validationPatterns.A,
            optional: false,
            minLength: 3,
            maxLength: 3,
            fieldName: "Shipment Currency"
        },
        shipmentValue: {
            ...validationPatterns.ND2,
            optional: false,
            minLength: 1,
            maxLength: 12,
            fieldName: "Shipping Value",
        },
        totalShipmentPackages: {
            ...validationPatterns.N,
            optional: false,
            minLength: 1,
            maxLength: 7,
            fieldName: "Total Shipment Package",
        },
        totalItems: {
            ...validationPatterns.N,
            optional: false,
            minLength: 1,
            maxLength: 7,
            fieldName: "Total Items",
        },
        invoiceNumber: {
            ...validationPatterns.P,
            optional: false,
            minLength: 0,
            maxLength: 21,
            fieldName: "Invoice Number", 
        },
        invoiceDate: {
            ...validationPatterns.N,
            optional: false,
            minLength: 12,
            maxLength: 15,
            fieldName: "Invoice Date", 
        },
        invoiceTotal: {
            ...validationPatterns.ND2,
            optional: false,
            minLength: 1,
            maxLength: 15,
            fieldName: "Invoice Amount", 
        }
    },
    Item: {
        commercialDescription: {
            ...validationPatterns.P,
            optional: false,
            minLength: 1,
            maxLength: 280,
            fieldName: "Commercial Description Of Goods", 
        },
        countryOfOrigin: {
            ...validationPatterns.A,
            optional: false,
            minLength: 2,
            maxLength: 2,
            fieldName: "Country of Origin", 
        },
        commodityCode: {
            ...validationPatterns.AN,
            optional: false,
            minLength: 10,
            maxLength: 10,
            fieldName: "Commodity Code", 
        },
        commodityCodeE: {
            ...validationPatterns.AN,
            optional: false,
            minLength: 8,
            maxLength: 8,
            fieldName: "Commodity Code", 
        },
        additionalCode1: {
            ...validationPatterns.AN,
            optional: true,
            minLength: 4,
            maxLength: 4,
            fieldName: "Additional Codes", 
        },
        procedure :{
            ...validationPatterns.PROCEDURE,
            optional: false, 
            minLength: 7,
            maxLength: 7,
            fieldName: "Procedure",
        },
        preference: {
            ...validationPatterns.N,
            optional: false, 
            minLength: 3,
            maxLength: 3,
            fieldName: "Preference"
        },
        packageCount: {
            ...validationPatterns.N,
            optional: false, 
            minLength: 0,
            maxLength: 5,
            fieldName: "Package Count"
        },
        packageType: {
            ...validationPatterns.AN,
            optional: false, 
            minLength: 2,
            maxLength: 2,
            fieldName: "Package Type"
        },
        unitType: {
            ...validationPatterns.U,
            optional: false, 
            minLength: 1,
            maxLength: 10,
            fieldName: "Unit Type"
        },
        unitTypeE: {
            ...validationPatterns.U,
            optional: false, 
            minLength: 1,
            maxLength: 10,
            fieldName: "Unit Type"
        },
        unitCount: {
            ...validationPatterns.ND8,
            optional: true, 
            minLength: 1,
            maxLength: 17,
            fieldName: "Unit Count"
        },
        unitCountE: {
            ...validationPatterns.ND8,
            optional: true, 
            minLength: 1,
            maxLength: 17,
            fieldName: "Unit Count"
        },
        unitPrice: {
            ...validationPatterns.ND8,
            optional: false, 
            minLength: 1,
            maxLength: 17,
            fieldName: "Unit Price"
        },
        unitPriceE: {
            ...validationPatterns.ND8,
            optional: false, 
            minLength: 1,
            maxLength: 17,
            fieldName: "Unit Price"
        },
        unitValue: {
            ...validationPatterns.ND2,
            optional: false, 
            minLength: 1,
            maxLength: 12,
            fieldName: "Unit Value"
        },
        packageMark: {
            ...validationPatterns.P,
            optional: false, 
            minLength: 0,
            maxLength: 42,
            fieldName: "Package Mark"
        },
        vmCode: {
            ...validationPatterns.N,
            optional: false, 
            minLength: 1,
            maxLength: 1,
            fieldName: "VM Code"
        },
        adjustmentCode: {
            ...validationPatterns.AN,
            optional: false, 
            minLength: 1,
            maxLength: 1,
            fieldName: "Adjustment Code"
        },
        adjustmentPercentage: {
            ...validationPatterns.ND,
            optional: true, 
            minLength: 1,
            maxLength: 14,
            fieldName: "Adjustment Percentage"
        },
        supUnitsQuantity: {
            ...validationPatterns.N11D3,
            optional: true, 
            minLength: 0,
            maxLength: 14,
            fieldName: "SUP Units "
        },
        supUnitsValue: {
            ...validationPatterns.N11D3,
            optional: true, 
            minLength: 0,
            maxLength: 14,
            fieldName: "3rd Quantity"
        },
        grossMass: {
            ...validationPatterns.N11D7,
            optional: false, 
            minLength: 0,
            maxLength: 14,
            fieldName: "Gross Mass"
        },
        netMass: {
            ...validationPatterns.N11D7,
            optional: false, 
            minLength: 0,
            maxLength: 14,
            fieldName: "Net Mass"
        },
        quotaNumber: {
            ...validationPatterns.N,
            optional: true, 
            minLength: 6,
            maxLength: 6,
            fieldName: "Quota Number"
        },
        statValueE: {
            ...validationPatterns.ND2,
            optional: false, 
            minLength: 0,
            maxLength: 12,
            fieldName: "Stat Value"
        },
        statValue: {
            ...validationPatterns.ND2,
            optional: true, 
            minLength: 0,
            maxLength: 12,
            fieldName: "Stat Value"
        },
        unDangerousGoods: {
            ...validationPatterns.N,
            optional: true, 
            minLength: 4,
            maxLength: 4,
            fieldName: "UN Dangerous Code"
        },
        prevDocType: {
            ...validationPatterns.AN,
            optional: false, 
            minLength: 0,
            maxLength: 6,
            fieldName: "Previous Document Type"
        },
        prevDocRef: {
            ...validationPatterns.P,
            optional: false, 
            minLength: 0,
            maxLength: 35,
            fieldName: "Previous Document Reference"
        },
        prevDocDeclaration: {
            ...validationPatterns.A,
            optional: false, 
            minLength: 1,
            maxLength: 1,
            fieldName: "Previous Document Declaration"
        },
        ref: {
            ...validationPatterns.U,
            optional : true,
            minLength: 1,
            maxLength: 35,
            fieldName : "Reference"
        },
        status: {
            ...validationPatterns.U,
            optional : false,
            minLength: 1,
            maxLength: 35,
            fieldName : "Doc Status"
        },
        reason: {
            ...validationPatterns.P,
            optional : true,
            minLength: 1,
            maxLength: 70,
            fieldName : "Reason"
        },
        part: {
            ...validationPatterns.AN,
            optional : true,
            minLength: 0,
            maxLength: 5,
            fieldName : "Part"
        },
        quantity: {
            ...validationPatterns.N11D3,
            optional : true,
            minLength: 1,
            maxLength: 14,
            fieldName : "Quantity"
        },
        additionalInfoCode: {
            ...validationPatterns.P,
            optional : true,
            minLength: 5,
            maxLength: 5,
            fieldName : "Additional Info Code"
        },
        additionalStatementText: {
            ...validationPatterns.P,
            optional : true,
            minLength: 1,
            maxLength: 70,
            fieldName : "Additional Info Statement Text"
        },
        taxType: {
            ...validationPatterns.AN,
            optional : false,
            minLength: 3,
            maxLength: 3,
            fieldName : "Tax Type"  
        },
        mopCode: {
            ...validationPatterns.A,
            optional : true,
            minLength: 1,
            maxLength: 1,
            fieldName : "Mode Of Payment"  
        },
        taxRate: {
            ...validationPatterns.AN,
            optional : true,
            minLength: 1,
            maxLength: 3,
            fieldName : "Tax Rate"  
        },
        overrideCode: {
            ...validationPatterns.A,
            optional : true,
            minLength: 3,
            maxLength: 3,
            fieldName : "Override Code"  
        },
        taxBase: {
            ...validationPatterns.ND2,
            optional : true,
            minLength: 1,
            maxLength: 12,
            fieldName : "Tax Base"  
        },
        taxAmount: {
            ...validationPatterns.ND2,
            optional : true,
            minLength: 1,
            maxLength: 12,
            fieldName : "Tax Amount"   
        }
    }
}
